import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DrawerIframe from "../common/DrawerIframe";
import { TTP_TEAM_URL } from "../../config";
const TaskType = ({ children }) => {
  const auth = useSelector((state) => state.auth);
  const [fiduciaryId, setFiduciaryId] = useState(null);
  useEffect(() => {
    if (auth.navCommunity) {
      setFiduciaryId(auth.navCommunity.id);
    }
  }, [auth.navCommunity]);

  const params = [];
  let powerTeamUrl = TTP_TEAM_URL + "/task-types";

  const preferences =
    auth.user && auth.navCommunity && auth.user.userOrganizations.length > 0
      ? auth.user.userOrganizations.find(
          (organization) => organization.id === auth.navCommunity.id
        ).authorisation.preferences
      : {};

  if (fiduciaryId) {
    params.push("without_header");
    params.push("without_menu");
    params.push("organization_id=" + fiduciaryId);
    return <DrawerIframe src={powerTeamUrl} params={params} hasAccess={preferences.allowAccessTaskTypeSetting} />;
  }
  return <></>;
};

export default TaskType;
